import { IOrderAddon } from './order-addon.model';

export interface IOrderMenu {
  menuId?: number | null;
  menuTitle?: string | null;
  variantId?: number | null;
  menuVariantTitle?: string | null;
  price?: number | null;
  quantity?: number | null;
  sumOfMenu?: number | null;
  menuCosts?: number | null;
  addons?: IOrderAddon[] | null;
  remark?: string | null;
  hash?: string | null;
  nonfood?: boolean | null;
  imagePath?: string | null;
}

export class OrderMenu implements IOrderMenu {
  constructor(
    public menuId?: number | null,
    public menuTitle?: string | null,
    public variantId?: number | null,
    public menuVariantTitle?: string | null,
    public price?: number | null,
    public quantity?: number | null,
    public sumOfMenu?: number | null,
    public menuCosts?: number | null,
    public addons?: IOrderAddon[] | null,
    public remark?: string | null,
    public hash?: string | null,
    public nonfood?: boolean | null,
    public imagePath?: string | null
  ) {}
}
